import { render, staticRenderFns } from "./correct_appoint_details.vue?vue&type=template&id=2223a365&scoped=true&"
import script from "./correct_appoint_details.vue?vue&type=script&lang=js&"
export * from "./correct_appoint_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2223a365",
  null
  
)

export default component.exports